/* Click and collect line. Pairs with snippets/pickup-line.liquid (facts and sources are listed there).
   Picks ONE line for where the shopper is and lists the other pickup points under "Other pickup points".
   Where the shopper is, in order: the postcode the freight calculator saved (localStorage ase.postcode, mapped to a
   state), else airless-stock-sync /api/geo (approximate state from the IP, region code only, cached for the tab
   session), else no location. Display only: it never writes to the cart. */
(function (root) {
  'use strict';
  var MIN = 100000; /* cents: Refuelling Solutions points take orders of $1,000 or more */
  var RFS = {
    NSW: { name: 'Smithfield NSW', days: '2 to 4 days' },
    SA: { name: 'Largs North SA', days: '1 to 3 days' },
    WA: { name: 'Rockingham WA', days: '4 to 7 days' }
  };
  var money = function (c) { return '$' + (c / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var fresh = function (iso, hours) { var t = Date.parse(iso); return Number.isFinite(t) && (Date.now() - t) / 3600e3 < hours; };

  /* s: { state, graco, db (qty at Deception Bay), derrimut (Graco has stock), basis (cents) }
     returns { key, lead, alt, others[] }; lead has no "Click and collect" prefix and starts lower case; alt is an
     optional second short line. States (Jacob, 20 Oct 2026): ACT = Smithfield NSW, TAS = Derrimut VIC, NT and unknown =
     Deception Bay. NSW sits between the other points, so its shoppers also get Deception Bay and Derrimut on a second
     line, and under $1,000 the best of those leads with Smithfield's $1,000 note second. */
  function view(s) {
    var dbWhen = s.db > 0 ? 'ready within the hour' : (s.graco ? 'usually ready in 3 to 5 days' : 'any order');
    var dbLead = 'from Deception Bay QLD, ' + dbWhen + '.';
    var derLead = 'from our Derrimut, VIC warehouse once paid: allow 3 to 4 hours, then wait for the pickup email.';
    var der = !!(s.graco && s.derrimut);
    var dbShort = 'Deception Bay QLD (' + (s.db > 0 ? 'ready within the hour' : (s.graco ? 'usually 3 to 5 days' : 'any order')) + ')';
    var derShort = 'Derrimut, VIC (allow 3 to 4 hours)';
    var st = s.state === 'ACT' ? 'NSW' : s.state;
    var shown = ['DB'];
    var key = 'DB';
    var lead = dbLead;
    var alt = '';
    if ((st === 'VIC' || st === 'TAS') && der) {
      key = 'VIC'; shown = ['VIC'];
      lead = derLead;
    } else if (st === 'NSW') {
      key = 'NSW';
      if (s.basis >= MIN) {
        shown = ['NSW', 'DB'].concat(der ? ['VIC'] : []);
        lead = 'from Smithfield NSW on orders of $1,000 or more, usually ready in 2 to 4 days.';
        alt = 'Also ' + dbShort + (der ? ' or ' + derShort : '') + '.';
      } else {
        var note = 'Smithfield NSW on orders of $1,000 or more (' + money(MIN - s.basis) + ' short).';
        if (s.db > 0 || !der) {
          shown = ['DB', 'NSW'].concat(der ? ['VIC'] : []);
          lead = dbLead;
          alt = (der ? 'Or ' + derShort + '. ' : '') + note;
        } else {
          shown = ['VIC', 'DB', 'NSW'];
          lead = derLead;
          alt = 'Or ' + dbShort + '. ' + note;
        }
      }
    } else if (RFS[st]) {
      key = st; shown = [st];
      var r = RFS[st];
      lead = s.basis >= MIN
        ? 'from ' + r.name + ' on orders of $1,000 or more, usually ready in ' + r.days + '.'
        : 'from ' + r.name + ' on orders of $1,000 or more (usually ' + r.days + '). This order is ' + money(MIN - s.basis) + ' short.';
    }
    var all = [
      ['DB', 'Deception Bay QLD: any order' + (s.db > 0 ? ', ready within the hour' : (s.graco ? ', usually 3 to 5 days' : ''))],
      ['VIC', s.graco ? 'Derrimut, VIC: paid orders, allow 3 to 4 hours, wait for the pickup email' : ''],
      ['NSW', 'Smithfield NSW: orders of $1,000 or more, usually 2 to 4 days'],
      ['SA', 'Largs North SA: orders of $1,000 or more, usually 1 to 3 days'],
      ['WA', 'Rockingham WA: orders of $1,000 or more, usually 4 to 7 days']
    ];
    return { key: key, lead: lead, alt: alt, others: all.filter(function (x) { return shown.indexOf(x[0]) < 0 && x[1]; }).map(function (x) { return x[1]; }) };
  }

  /* Postcode to state, the same ranges as assets/freight-calc.js (display only) */
  var RANGES = [['ACT', 200, 299], ['NT', 800, 999], ['NSW', 1000, 2599], ['ACT', 2600, 2618], ['NSW', 2619, 2898],
    ['ACT', 2900, 2920], ['NSW', 2921, 2999], ['VIC', 3000, 3999], ['QLD', 4000, 4999], ['SA', 5000, 5999],
    ['WA', 6000, 6797], ['WA', 6800, 6999], ['TAS', 7000, 7999], ['VIC', 8000, 8999], ['QLD', 9000, 9999]];
  function stateOf(pc) {
    if (!/^\d{4}$/.test(String(pc || ''))) return null;
    var n = Number(pc);
    for (var i = 0; i < RANGES.length; i++) if (n >= RANGES[i][1] && n <= RANGES[i][2]) return RANGES[i][0];
    return null;
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { view: view, stateOf: stateOf }; return; }
  if (root.__asePickup) return;
  root.__asePickup = true;

  var get = function (store, k) { try { return root[store].getItem(k); } catch (e) { return null; } };
  var put = function (store, k, v) { try { root[store].setItem(k, v); } catch (e) { /* storage blocked */ } };
  var state = stateOf(get('localStorage', 'ase.postcode'));
  var cartCents = null;
  var boxes = Array.prototype.slice.call(document.querySelectorAll('[data-pickup]'));
  if (!boxes.length) return;

  function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function render(box) {
    var pdp = box.closest('[data-pdp]') || document;
    var idIn = pdp.querySelector('input[name="id"]');
    var qIn = pdp.querySelector('input[name="quantity"]');
    var vs = box.__v;
    if (!vs) { try { vs = box.__v = JSON.parse(box.querySelector('[data-pickup-variants]').textContent); } catch (e) { return; } }
    var v = (idIn && vs[idIn.value]) || vs[Object.keys(vs)[0]];
    if (!v) return;
    var graco = box.dataset.graco === 'true';
    var db = graco && v.go && v.go.qty > 0 && fresh(v.go.at, 49) ? v.go.qty : 0;
    var st = v.portal && v.portal.status;
    if (!st && v.ss === 'Ships now') st = 'in_stock';
    var derrimut = graco && (st === 'in_stock' || st === 'low') && v.portal && fresh(v.portal.at, 25);
    var qty = Math.max(1, Number(qIn && qIn.value) || 1);
    var cart = cartCents == null ? Number(box.dataset.cartCents) || 0 : cartCents;
    var out = view({ state: state, graco: graco, db: db, derrimut: !!derrimut, basis: v.price * qty + cart });
    var lead = out.lead;
    if (box.dataset.label !== 'true') lead = lead.charAt(0).toUpperCase() + lead.slice(1);
    box.querySelector('[data-pickup-lead]').textContent = lead;
    var altEl = box.querySelector('[data-pickup-alt]');
    if (altEl) { altEl.textContent = out.alt; altEl.hidden = !out.alt; }
    var more = box.querySelector('.pk__more');
    if (more) more.hidden = !out.others.length;
    box.querySelector('[data-pickup-list]').innerHTML = out.others.map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
    box.dataset.dbReady = db > 0 ? 'true' : 'false';
    box.dataset.shown = out.key;
  }
  function all() { boxes.forEach(render); }
  all();

  /* Location: the freight calculator's postcode wins; the IP guess only fills a gap */
  document.addEventListener('ase:postcode', function (e) { var s = stateOf(e.detail); if (s) { state = s; all(); } });
  if (!state) {
    var cached = get('sessionStorage', 'ase.geo');
    if (cached != null) { state = cached || null; all(); } else if (root.fetch) {
      fetch(boxes[0].dataset.geo, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        var reg = j && typeof j.region === 'string' ? j.region : '';
        put('sessionStorage', 'ase.geo', reg);
        if (!state && reg) { state = reg; all(); }
      }).catch(function () { /* no location: keep Deception Bay */ });
    }
  }
  /* Size and quantity changes (theme.js sets input[name=id] in its own change handler, which runs first) */
  document.addEventListener('change', function () { all(); });
  document.addEventListener('input', function (e) { if (e.target && e.target.name === 'quantity') all(); });
  /* The cart total is server rendered; refresh it after an add so the $1,000 test stays true */
  function cartNow() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { cartCents = c.total_price; all(); }).catch(function () {});
  }
  document.addEventListener('submit', function (e) { var a = e.target && e.target.getAttribute('action') || ''; if (/\/cart\/add/.test(a)) setTimeout(cartNow, 1500); });
})(typeof window !== 'undefined' ? window : globalThis);
